import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useParentScope } from "@/context/ParentContext";
import { EmptyState, ErrorState, Loading } from "@/components/States";
import { Button } from "@/components/ui/button";
import { ParentDashboardContent } from "@/pages/parent/DashboardContent";

export default function ParentDashboard() {
  const { student, students } = useParentScope();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    if (!student) return;
    setError("");
    setData(null);
    try {
      const res = await api.get(`/parent/students/${student.id}/dashboard`);
      setData(res.data);
    } catch (err) {
      setError(apiError(err, "No pudimos cargar el panel."));
    }
  }, [student]);

  useEffect(() => {
    load();
  }, [load]);

  if (!students.length) {
    return (
      <EmptyState
        title="Crea el perfil de tu hijo"
        description="MAIKY necesita un perfil de estudiante para organizar materias, examenes y apuntes."
        action={
          <Link to="/p/estudiantes">
            <Button className="estudia-touch rounded-xl bg-blue-600 font-semibold" data-testid="dashboard-create-student-btn">
              Crear perfil
            </Button>
          </Link>
        }
        testId="dashboard-empty"
      />
    );
  }

  if (error) return <ErrorState message={error} onRetry={load} />;
  if (!data) return <Loading label="Calculando progreso real..." />;

  return <ParentDashboardContent data={data} />;
}
